import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  logo: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  headingBox: { textAlign: 'center' },
}));

const Banner = () => {
  const classes = useStyles();

  return (
    <div className={classes.headingBox}>
      <img src={'/logo-light-stacked.svg'} alt="Trustate Logo" className={classes.logo} />
      <div>
        <Typography variant="h4">Start an Estate</Typography>
      </div>
    </div>
  );
};

export default Banner;
